export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // 修改密码
  PASSWORD_PAGE = '/password',
  // basic home path
  BASE_HOME = '/portal/main',
  // callback page
  CALLBACK_PAGE = '/callback',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
}
